<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-left bg-no-repeat"
    :style="bannerStyle"
  >
    <div class="container-wrap flex h-mobile-banner py-2 tablet:h-banner">
      <div class="flex w-full flex-col justify-center">
        <div>
          <h1
            class="text-h1 banner-title mb-2 whitespace-pre-line"
            v-text="sectionData.name"
          />
          <p class="banner-description is-mobile-hidden mb-3">
            {{ sectionData.description }}
          </p>
        </div>
        <TheButton
          v-if="sectionData.link"
          :id="isCN ? 'tracking_dialogue' : undefined"
          :to="sectionData.link?.url"
          :title="sectionData.link?.name || ''"
          class="w-[180px]"
          @click="handleClick"
        >
          <span class="text-sm">{{ sectionData.link?.name }}</span>
        </TheButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { ISection } from '@/assets/types/api/Pages';

  interface IProps {
    sectionData: ISection;
  }

  withDefaults(defineProps<IProps>(), {
    sectionData: () => ({
      code: null,
      name: null,
      description: null,
      type: 1,
      imageUrl: null,
      imageAlt: null,
      link: null,
      align: null,
      theme: null,
      subSections: [],
    }),
  });

  const { blobDomain } = useWebsite();
  const { isCN } = useLanguage();

  const bannerStyle = computed((): string => {
    const imageUrl = isCN.value
      ? `${blobDomain.value}/wise-paas-marketplace/partners/partnership_banner.webp`
      : `${blobDomain.value}/wise-paas-marketplace/partners/banner.webp`;

    return `background-image: url(${imageUrl})`;
  });

  const handleClick = (): void => {
    window.gtag('event', 'site_click', { Item: 'JoinUsNowButton' });
  };
</script>
